import React, {PureComponent} from "react";
import "../../sass/components/search-bar.scss";
import Api from "../utils/api_calls";
import Common from "../utils/common";
import SearchSuggest from './search-suggest';
import ConfigurationHelper from "../../src/configuration/ClientConfigurationHelper";
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const {isSearchPage} = TVSite;

const baseUrl =  ConfigurationHelper.getGlobalConfiguration().public_base_url + ConfigurationHelper.getGlobalConfiguration().sub_folder;

export default class SearchBar extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            value: props.default || "",
            lastValue: "",
            to: null,
            Results: [],
            loading: true,
            pageResults: -1,
            loadingResults: false,
            hasSuggests: true,
            hasResults: true,
            lastPage: false
        };
        this.change = this.change.bind(this);
        this.delayedCb = Common.debounce(this.handleCb, 200);
        this.click = this.click.bind(this);
        this.clean = this.clean.bind(this);
        this.getResults = this.getResults.bind(this);
        this.clearSuggest = this.clearSuggest.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.overlay = this.overlay.bind(this);
    }

    change(event) {
        const value = event.target.value;
        if ('string' !== typeof value || "undefined" === value || value === "" || /^\s*$/.test(value)) return this.clean(event);
        this.setState({
            value: value
        });
        event.persist();
        this.delayedCb(event);
    }

    handleCb(event) {
        const value = event.target.value;

        const that = this;

        if (!isMobile) {
            this.clearSuggest();
            setTimeout(() => {
                if (!that.state.loadingResults)
                    that.getResults(value);
            }, 0);
            this.overlay(value);
        }
        let state = {
            value: value
        };
        if (!value) {
            state = {
                value: value,
                lastValue: value,
                hasResults: true,
                hasSuggests: true
            }
        }
        this.setState(state);
    }

    overlay(value) {
        if (isMobile || isSearchPage)
            return;
        const that = this;
        const overlay = document.getElementById("search-overlay");
        if (overlay && !value) {
            overlay.remove();
            that.clearSuggest();
            document.body.classList.remove('openResults');
        } else if (value) {
            if (overlay)
                return;
            const body = document.getElementsByTagName("body")[0];
            let el = document.createElement("div");
            el.className = "search-overlay";
            el.setAttribute("id", "search-overlay");
            el.addEventListener("click", () => {
                this.overlay("");
            }, false);
            document.body.classList.add('openResults');
            body.appendChild(el);
        }
    }

    click(event) {
        event.preventDefault();
        if (this.state.value)
            window.location.href = baseUrl + "/search/?s=" + encodeURIComponent(this.state.value);
    }

    clean(event) {
        if (event)
            event.preventDefault();

        const currentValue = this.state.value;
        this.setState({
            value: "",
            lastValue: currentValue
        });
        this.overlay("");
        this.clearSuggest();
    }

    getResults(keyword) {
        if (!keyword) return;
        const that = this;
        that.setState({loading: true, loadingResults: true});
        let {pageResults} = this.state;

        Api.suggestResults(++pageResults, keyword, 6).done((data) => {
            that.setState({lastPage: (!data.length || data.length < 6)});
            if (data.length > 0) {
                let initialData = that.state.Results;
                that.setState({
                    Results: initialData.concat(data),
                    loadingResults: false,
                    hasResults: true,
                    loading: false
                });
            } else {
                that.setState({
                    loadingResults: false,
                    hasResults: false,
                    loading: false
                });
            }
        });
    }

    clearSuggest() {
        this.setState({
            Results: [],
            value: "",
            pageResults: -1
        });
    }

    onScroll(e) {
        const target = e.currentTarget,
            targetTop = target.scrollTop,
            targetCalcHeight = target.clientHeight - target.scrollHeight,
            percentScrolled = Math.round(Math.abs((targetTop * 100) / targetCalcHeight));

        let {value, pageResults, loading, lastPage} = this.state;

        if ((percentScrolled >= 65 && percentScrolled <= 100) && !loading && !lastPage) {
            this.setState({
                pageResults: ++pageResults
            });
            this.getResults(value);
        }
    }

    render() {
        const {loading, value, lastValue, Results, hasSuggests} = this.state;
        const hasResults = Results.length > 0;
        const noResults = hasResults && hasSuggests;

        return <div>
            <div className="col-md-12 col-xs-12 col-sm-12 tvp-searchbar-wrapper">
                <form onSubmit={this.click} className={"tvp-searchbar z10000"}>
                    <input className="tvp-searchbar-input" value={value} placeholder="SEARCH VIDEOS"
                           onChange={this.change}/>
                    <div className="tvp-searchbar-button">
                        {value ? <div id="clear" className="clear" onClick={this.clean}>
                                <span className="cross"></span>
                                <span className="cross"></span>
                            </div> :
                            <div className="tvp-searchbar-button-img" onClick={this.click}
                                 style={{backgroundImage: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAsVBMVEUAAAD///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADE2tUTAAAAOnRSTlMAAAMGCQwPEhUYISozNjk/QkVIS1FUXWBsgYeNkJmcn6KlqKuxtLe6wMPJzM/S1djb3uHk6u3z9vn8HnHlvAAAASZJREFUeAHt1clS6kAUh/FuhtyLEYhKHNAoKBhAJAyGyPf+D2YYWlsWJ83Wyrf8V/2qq1dH6ZMryb6StLqTjGzSbSk7gfgxpth3IuGan9ahA+mwbRFFj0u2dQqJnwHT1m4JZkDmF5EYeKnuF1V7BeIC0gZWnj4Q9T8F2jKJgAuz5F0DkUwSeNcWqaSQyCSDJ5uoIWQiqQP3v0gPqEuksoHe8SubikT0HJbHf5krkfSBwCIh0JdJAExr38SbA4FM9BgY1A/EGwFjVUCan0BytVvCBXmzhkjybtj2MYiGKWCMSPTtBjtjJKKDKaZRaoxI8i4f3lKW47umOjdGJiaVZxlnYkzScCaWcSWCEYgxkxOIMf+ciTE97UaMWfFcPY0o70z93StWki8W2UPDzqpZLQAAAABJRU5ErkJggg==)"}}></div>
                        }

                    </div>
                </form>

            </div>
            <div className="col-xs-12">
                {(!isMobile && !isSearchPage) && <SearchSuggest
                    onScroll={this.onScroll}
                    value={value}
                    loading={loading}
                    lastValue={lastValue}
                    openResults={!!value}
                    Results={Results}
                    noResults={noResults}
                    />}
            </div>
        </div>
    }
}